module.exports = __webpack_public_path__ + "static/media/events_background.11c531c3.jpg";